import { post } from "./post";
import {
  userData,
  selectedOptic,
  calculateSectionTotal,
  checkOfferPrice,
} from "./utils";

const getPatientDto = async (idPaciente) => {
  if (!idPaciente || idPaciente === -1) return 0;
  const response = await post("ObtenerDatosPaciente.php", {
    token: userData.token,
    optica: selectedOptic.id,
    idPaciente,
  });
  return parseFloat(response?.descuentoEspecial) || 0;
};

// Calcula PVP, descuento y total de un producto aplicando el descuento del
// paciente, igual que en la pantalla de venta: si el producto está de oferta
// se queda el precio más bajo de los dos, y si el descuento del paciente
// supera el máximo del producto no se aplica.
export const getPatientProductPrice = async ({
  product,
  idPaciente,
  createPopupQuestion,
  removePopupQuestion,
}) => {
  const offerPvp = checkOfferPrice(product);
  const patientDto = await getPatientDto(idPaciente);
  const noDto = {
    pvp: offerPvp,
    descuento: 0,
    total: calculateSectionTotal(offerPvp, 0),
  };

  if (patientDto <= 0) return noDto;

  const dtoMax = parseFloat(product.dtoMaximo);
  if (!isNaN(dtoMax) && patientDto > dtoMax) {
    if (offerPvp === product.pvp) {
      createPopupQuestion(
        `El descuento del paciente (${patientDto}%) es mayor que el máximo permitido para este producto (${dtoMax}%). No se puede aplicar descuento.`,
        removePopupQuestion,
        null,
        "Cerrar",
      );
    }
    return noDto;
  }

  const total = calculateSectionTotal(product.pvp, patientDto);
  if (total >= offerPvp) return noDto;

  return { pvp: product.pvp, descuento: patientDto, total };
};
